module.exports = __webpack_public_path__ + "static/img/przybornik_wielkosc1.b9a4ef20.png";